import React, { useContext } from 'react';
import c from 'classnames';
import { ThemeSurface } from '@wix/da-react-context/pkg/constants';
import { PopupContext } from '../../../../popups/PopupContext';
import ModalBody from '../../../base/ModalBody';
import ModalFormBody from '../../../base/ModalFormBody';
import s from './ModalLayout.scss';
/**
 * A modal layout with slots for a `header`, `content`, and `footer`.
 *
 * Note: If you need the slots separated by borders, consider using `<SegmentedModalLayout />`. They're separated for now
 * for safety down the road. There are too many possible modal designs to put all of these style options into one component.
 */ const ModalLayout = ({ isFullscreen, header, headerBorder, preamble, content, footer, footerBorder, className, contentClassName, footerPadding = 'default', innerScrollRef, onSubmit, withScrollableContentWrapper = true })=>{
    const { setDefaultScrollableRef } = useContext(PopupContext);
    const children = /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: c(s['header-and-preamble'], headerBorder && s['header-and-preamble-border'])
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['header']
    }, header), /** We expect the consumer to handle the layouting here */ preamble), /*#__PURE__*/ React.createElement("div", {
        className: c(s['content'], withScrollableContentWrapper && s['scrollable'], contentClassName),
        ref: (node)=>{
            if (withScrollableContentWrapper) {
                innerScrollRef && innerScrollRef(node);
                // Set the default scrollable, see ModalRoot for the logic
                setDefaultScrollableRef && setDefaultScrollableRef(node);
            }
        }
    }, content), footer && /*#__PURE__*/ React.createElement("div", {
        className: c(s['footer'], footerBorder && s['footer-border'], s[`footer-padding-${footerPadding}`])
    }, footer));
    return onSubmit ? /*#__PURE__*/ React.createElement(ModalFormBody, {
        className: c(s['root'], isFullscreen && s['fullscreen'], className),
        surfaceType: ThemeSurface.TERTIARY,
        isFullscreen: isFullscreen,
        onSubmit: onSubmit
    }, children) : /*#__PURE__*/ React.createElement(ModalBody, {
        className: c(s['root'], isFullscreen && s['fullscreen'], className),
        surfaceType: ThemeSurface.TERTIARY,
        isFullscreen: isFullscreen
    }, children);
};
ModalLayout.displayName = 'ModalLayout';
export default ModalLayout;

//# sourceMappingURL=ModalLayout.js.map